<div class="delete-account-container">
  <div *ngIf="!isSubmitted" class="form-container">
    <div class="logo-image-container">
      <img
        src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/delete-account-hifpt/logo-FTELxHi%20FPT-4x.png"
        width="160px"
        height="77px"
        alt="Logo Hifpt x Ftel"
      />
    </div>

    <h4 class="title-form">Xóa tài khoản Hi FPT?</h4>
    <p class="description-form">
      Nhập thông tin của bạn và xác nhận xóa tài khoản
    </p>

    <form
      (ngSubmit)="handleSubmit()"
      [formGroup]="deleteAccountForm"
      class="form-wrapper"
    >
      <div class="form">
        <input
          type="tel"
          formControlName="phone"
          [minlength]="10"
          [maxlength]="10"
          autocomplete="off"
          name="phone"
          required
        />
        <label class="label-phone">
          <span class="content-label">Nhập số điện thoại</span>
        </label>
      </div>
      <button
        type="submit"
        [disabled]="deleteAccountForm.invalid"
        class="button-submit"
      >
        Xác nhận
      </button>
    </form>
  </div>

  <div *ngIf="isSubmitted" class="popup-annouce-success">
    <div class="image-container">
      <img
        src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/delete-account-hifpt/tick-circle-success-4x.png"
        alt="Icon success"
        width="72px"
        height="72px"
      />
    </div>
    <h4 class="title-popup-success">Yêu cầu thành công</h4>
    <p class="description-guide-delete-account">
      Yêu cầu đã được ghi nhận và đang xử lý. Quý khách cũng có thể vào ứng dụng
      <strong>Hi FPT</strong> chọn tab <strong>Tài khoản</strong>, tại mục
      <strong>Điều khoản sử dụng</strong> chọn chức năng
      <strong>Xoá tài khoản</strong>.
    </p>
  </div>
</div>
